<topbar />

<main-menu />

<section id="topbar" class="shadow-sm">
  <ng-content select="[header-page]"></ng-content>
</section>

<main id="wrapper">
  <div class="container-fluid">
    <ng-content select="[wrapper]"></ng-content>
  </div>
</main>
